export const facilityBookingExportColumns = [
	{ label: 'Sr No', key: 'index' },
	{
		label: 'Community',
		render: r => r?.hub?.name || '',
	},
	{
		label: 'Sanstha',
		render: r => r?.sansthaId?.name || '',
	},
	{
		label: 'User Name',
		render: r => (r?.userId ? `${r.userId.firstName || ''} ${r.userId.lastName || ''}`.trim() : ''),
	},
	{
		label: 'User Mobile',
		render: r => r?.userId?.mobile || '',
	},
	{
		label: 'Facility',
		render: r => r?.facility?.facilityName || '',
	},
	{
		label: 'Payment Type',
		render: r => (r?.isOffline ? 'Offline' : 'Online'),
	},
	{
		label: 'Amount',
		render: r => r?.amount ?? '',
	},
	{
		label: 'Payment Mode',
		render: r => r?.paymentMode || '',
	},
	{
		label: 'Payment Ref No',
		render: r => r?.paymentRef || '',
	},
	{
		label: 'Payment Date',
		render: r => (r?.paymentDate ? new Date(r.paymentDate).toLocaleDateString('en-IN') : ''),
	},
	{
		label: 'Status',
		render: r => r?.status || '',
	},
]
